import React, { useState, useEffect } from 'react';
import { Alert, Button } from 'antd';
import { WifiOutlined, DisconnectOutlined } from '@ant-design/icons';

const NetworkStatus = () => {
  const [online, setOnline] = useState(navigator.onLine);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let hideTimer;
    const handleOnline = () => {
      setOnline(true);
      setVisible(true);
      // 3秒后自动隐藏在线提示
      hideTimer = setTimeout(() => setVisible(false), 3000);
    };

    const handleOffline = () => {
      setOnline(false);
      setVisible(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // 首次离线时立即显示
    if (!navigator.onLine) {
      setVisible(true);
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      if (hideTimer) clearTimeout(hideTimer);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        padding: '0 16px',
      }}
    >
      {online ? (
        <Alert
          message="网络已恢复"
          type="success"
          showIcon
          icon={<WifiOutlined />}
          banner
          closable
          onClose={() => setVisible(false)}
        />
      ) : (
        <Alert
          message="网络连接已断开，部分功能可能无法正常使用"
          description={<Button size="small" type="link" onClick={() => window.location.reload()}>点击刷新</Button>}
          type="warning"
          showIcon
          icon={<DisconnectOutlined />}
          banner
          closable={false}
        />
      )}
    </div>
  );
};

export default NetworkStatus;
